<template>
  <div class="header">
    <div class="main">
      <h1 class="inline" @click="goPath2('/home')">
        <img src="../../assets/logo.png" alt="" />
      </h1>
      <nav class="fright">
        <div class="">
          <div
            class="fleft nav"
            @click.stop="goPath(item, index)"
            @mouseover="mouseoverNav(item)"
            :class="active == index ? 'active' : ''"
            v-for="(item, index) in navList"
            :key="index"
          >
            <h2>{{ item.name }}</h2>
            <transition name="bounce" appear v-if="subNav.length > 0">
              <div
                class="subNav"
                :class="active == index && subNav.length > 0 ? 'subActive' : ''"
                @mouseleave="subNav = []"
              >
                <div
                  @click.stop="goPath1(item1)"
                  :class="index1 == active1 ? 'active' : ''"
                  v-for="(item1, index1) in subNav"
                  @mouseenter="active1 = index1"
                  @mouseleave="active1 = -1"
                  :key="index1"
                >
                  {{ item1.name }}
                  <span></span>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </nav>
    </div>
    <div class="rightMenu" @click="drawer = true">
      <span>
        <i></i>
      </span>
    </div>
    <el-drawer
      size="200px"
      :append-to-body="true"
      :visible.sync="drawer"
      :direction="direction"
    >
      <div class="menu">
        <div
          @click.stop="goPath(item)"
          @mouseover="mouseoverNav(index, item)"
          v-for="(item, index) in navList"
          :key="index"
        >
          {{ item.name }}
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { getProductTree, applyDomainList, getDictList } from "../../api/index";
export default {
  data() {
    return {
      navList: [
        {
          name: "首页",
          path: "/home",
        },
        {
          name: "产品中心",
          path: "/product/index",
          children: [],
        },
        {
          name: "行业应用",
          path: "/apply",
          children: [],
        },
        {
          name: "质量与可靠性",
          path: "/zlykkx/zlgl",
          children: [],
        },
        {
          name: "服务支持",
          path: "/fwzc/onlineClass",
          children: [
            {
              name: "在线课堂",
              path: "/fwzc/onlineClass",
            },
            {
              name: "技术文章",
              path: "/fwzc/tecArticles",
            },
          ],
        },
        {
          name: "关于士模",
          path: "/about",
          children: [
            {
              name: "公司介绍",
              path: "/about",
            },
            {
              name: "新闻资讯",
              path: "/news",
            },
            {
              name: "联系我们",
              path: "/introduce",
            },
            {
              name: "销售与代理商",
              path: "/fwzc/xsydls",
            },
          ],
        },
        {
          name: "加入士模",
          path: "/joinUs",
        },
      ],
      active: 0,
      subNav: [],
      active1: -1,
      drawer: false,
      direction: "rtl",
    };
  },
  watch: {
    $route: {
      handler(n, o) {
        this.drawer = false;
      },
      deep: true,
    },
  },
  methods: {
    goPath2(path) {
      this.$router.push(path);
    },
    mouseoverNav(item) {
      this.subNav = item.children ? item.children : [];
    },
    goPath(item, index) {
      console.log(index);
      if (index > -1) {
        this.active = index;
      }
      let path = this.$route.path;
      if (path != item.path) {
        this.$router.push(item.path);
        document.documentElement.scrollTop = 0;
      }
    },
    goPath1(item) {
      if (item.path) {
        if (item.path == "/product/index") {
          this.$router.push({ path: item.path, query: { id: item.id } });
          document.documentElement.scrollTop = 0;
        } else if (item.path == "/apply") {
          this.$router.push({ path: item.path, query: { id: item.id } });
          document.documentElement.scrollTop = 0;
        } else {
          console.log(item.path);
          this.$router.push(item.path);
          document.documentElement.scrollTop = 0;
        }
      }
    },
  },
  mounted() {
    getProductTree().then((res) => {
      // console.log(res.data);
      let data = res.data;
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        this.$set(element, "path", "/product/index");
      }
      this.navList[1].children = res.data;
    });
    applyDomainList().then((res) => {
      let data = res.rows;
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        this.$set(element, "path", "/apply");
      }
      this.navList[2].children = res.rows;
    });
    getDictList("cms_quality_reliability").then((res) => {
      let data = res.data;
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        this.$set(element, "path", "/zlykkx/zlgl?id=" + element.dictValue);
        this.$set(element, "name", element.dictLabel);
      }
      this.navList[3].children = res.data;
    });
  },
};
</script>
<style scoped lang="scss">
@media (min-width: 300px) {
  .main {
    width: 300px;
  }

  nav {
    display: none;
  }

  .rightMenu {
    display: block;
  }
}

@media (min-width: 600px) {
  .main {
    width: 600px;
  }

  nav {
    display: none;
  }

  .rightMenu {
    display: block;
  }
}

@media (min-width: 700px) {
  .main {
    width: 700px;
  }

  nav {
    display: none;
  }

  .rightMenu {
    display: block;
  }
}

@media (min-width: 800px) {
  .main {
    width: 800px;
  }

  nav {
    display: none;
  }

  .rightMenu {
    display: block;
  }
}

@media (min-width: 1000px) {
  .main {
    width: 1000px;
  }

  nav {
    display: none;
  }

  .rightMenu {
    display: block;
  }
}

@media (min-width: 1100px) {
  .main {
    width: 1100px;
  }

  nav {
    display: block;
  }

  .rightMenu {
    display: none;
  }
}

/*>=1280的设备*/
@media (min-width: 1200px) {
  .main {
    width: 1200px;
  }

  nav {
    display: block;
  }

  .rightMenu {
    display: none;
  }
}

.header {
  position: fixed;
  width: 100%;
  background-color: rgba($color: #13458f, $alpha: 0.8);
  color: #fff;
  z-index: 999;

  img {
    height: 60px;
    margin-top: 10px;
  }
}

.noActive {
  span {
    display: none !important;
  }
}

.active1 {
  span {
    display: block;
  }
}

.subNav {
  display: none;
  position: absolute;
  background: #fff;
  color: #1e1e1e;
  width: 120px;
  line-height: 80px;
  z-index: 999;
  padding: 0 10px 10px 10px;
  top: 78px;
  // height: 300px;
  left: 50%;
  margin-left: -60px;

  // transition:height 1s;
  div {
    line-height: 40px;
    margin-top: 10px;
  }
}

.bounce-enter-active,
.bounce-leave-active {
  transition: all 1s;
}

.bounce-enter,
.bounce-leave-to {
  opacity: 0;
  // width: 0px;
}

.subNav {
  li {
    font-weight: bold;
    cursor: pointer;

    span {
      height: 3px;
      background-color: #fff;
    }
  }

  .active {
    span {
      display: block;
      width: 24px;
      height: 3px;
      background-color: #cf2b5d;
      margin: 0 auto;
    }
  }
}

.nav {
  position: relative;
  cursor: pointer;
  text-align: center;
  padding: 18px 14px;
  // width: 120px;
  h2 {
    font-size: 18px;
    line-height: 44px;
  }
}
.nav:hover {
  .subNav {
    display: block;
  }
  h2 {
    color: #cf2b5d;
  }
}
.nav.active {
  font-weight: bolder;
  // color: #cf2b5d;
  color: #cf2b5d;
  // background-color: #345689;
}

.rightMenu {
  width: 22px;
  height: 44px;
  position: absolute;
  right: 20px;
  top: 10px;
  cursor: pointer;

  span {
    width: 22px;
  }

  i {
    display: block;
    height: 2px;
    background-color: rgba(255, 255, 255, 0.8);
    position: absolute;
    -webkit-border-radius: 2px;
    -moz-border-radius: 2px;
    border-radius: 2px;
    top: 50%;
    width: 22px;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
  }

  i:before,
  i:after {
    width: 22px;
    height: 2px;
    background-color: rgba(255, 255, 255, 0.8);
    content: "";
    display: block;
    position: absolute;
    -webkit-transition: all 0.3s;
    -o-transition: all 0.3s;
    -moz-transition: all 0.3s;
    transition: all 0.3s;
    -webkit-border-radius: 2px;
    -moz-border-radius: 2px;
    border-radius: 2px;
  }

  i:after {
    top: 8px;
  }

  i:before {
    bottom: 8px;
  }
}

.menu {
  background-color: #fff;

  > div {
    text-align: center;
    line-height: 50px;
    border-bottom: 1px solid #eee;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header/index.vue